._assistantMessage_13rz2_1 {
  padding-left: 30px; }
  ._assistantMessage__item_13rz2_3:not(:last-child) {
    padding-bottom: 12px; }
  ._assistantMessage__wrapper_13rz2_5 {
    position: relative; }
  ._assistantMessage__icon_13rz2_7 {
    position: absolute;
    top: 0;
    left: 0; }
